import {apiback} from '../../../config';
import {Sync} from 'MWC';

export default {
    activeScreen: '',
    sendForm: async function(data) {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            // url = 'http://a-bank-dev9.ab.loc/api/v1/a-express-credit-application',
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: data.phone,
                        name: data.name,
                        message: data.message,
                        email: data.email,
                        attribute: data.attribute,
                        entity: data.entity,
                        okpo: data.okpo,
                        commission: data.commission,
                        rate: data.rate,
                        sum: data.sum,
                        cost: data.cost,
                        utm_source: 'site',
                        site: data.site,
                        company: data.company
                    },
                    hash: data.hash ? data.hash : '546B0B5BC97BE94B'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.activeScreen = 'success';
            }
        } catch (error) {
            this.activeScreen = 'error';
            return error;
        }
    }
};
